import React from 'react';
export const LoadingSpinner = ({ className = '' }) => {
    const customClass = `cb-spinner ${className}`;
    return React.createElement("div", { className: customClass });
};
